import Styles from './HorizontalLine.styles';

export const HorizontalLine = () => {
  return <Styles.HorizontalLine data-testId='horizontal-line' />;
};
